const BACKGROUND_ILLUSTRATION_COMPONENT_PROPS = {
  illustration: 'illustration_confirmation_warning',
  height: '120px',
  width: '120px',
};

export { BACKGROUND_ILLUSTRATION_COMPONENT_PROPS };
